import generateText from './generateText'
import generateDownloadMetaText from './generateDownloadMetaText'
import generateName from './generateName'
import generateFullDownloadableText from './generateFullDownloadableText'

const downloadPatFile = (pattern, user, team, includeErrors, includeData, includeHidden, txtFormat) => { 

  let text = generateFullDownloadableText(pattern, user, team, includeErrors, includeData, includeHidden, txtFormat);

  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', (generateName(pattern) || "untitled") + (txtFormat ? '.txt' : '.pat'));

  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);

}

export default downloadPatFile;



// WEBPACK FOOTER //
// ./src/pattern_utilities/downloadPatFile.js